export type Data = {
  installModalVisible: boolean;
  installCalloutVisible: boolean;
};

const initialState = {
  error: null,
  data: {
    installModalVisible: false,
    installCalloutVisible: false,
  } as Data,
};

export type State = typeof initialState;

export default initialState;
